// FILECONTENT_START src/common/components/Inputs/PasswordField/index.ts
import PasswordField from "./PasswordField";
export default PasswordField;
export type { PasswordFieldProps } from "./PasswordField";

// FILECONTENT_END src/common/components/Inputs/PasswordField/index.ts